<template>
  <div v-if="currentRoles.name === '委托方公司管理'" class="page-index entrust-index">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['委托方公司管理-新增']" class="btn-left" size="mini" @click="openModel()">添加委托方公司</el-button>
      <div style="flex:1"></div>
      <el-select v-if="userInfo.companyList.length > 0" class="search-input2" multiple collapse-tags v-model="query.companyIds" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <!-- <el-input  class="search-input" v-model="query.query" @keyup.enter.native="seach" placeholder="请输入委托方公司名称" /> -->
    </div>

    <el-table
        ref="userTable"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="委托方">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="address"
          label="生产地址">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="registerAddress"
          label="注册地址">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="postcode"
          label="邮编">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="contactNumber"
          label="联系方式">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="180"
          label="操作">
        <template slot-scope="scope">
          <el-tooltip v-if="currentRoles.roles['委托方公司管理-编辑']" content="编辑" placement="top">
            <el-button size="mini" @click.stop="_getDetail(scope.row)">
              <i class="icon el-icon-edit"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip v-if="currentRoles.roles['委托方公司管理-删除']" content="删除" placement="top">
            <el-button size="mini" @click.stop="handleDelete(scope.row)">
              <i class="icon el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="添加委托公司"
        :visible.sync="dialogVisible"
        width="550px"
        :before-close="handleClose">
      <el-form ref="model1" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="公司" prop="companyId">
          <el-select v-model="form.companyId" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="委托方名称" prop="name">
          <el-input placeholder="请输入委托方名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="生产地址" prop="address">
          <el-input placeholder="请输入生产地址" v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="registerAddress">
          <el-input placeholder="请输入注册地址" v-model="form.registerAddress"></el-input>
        </el-form-item>
        <el-form-item label="邮政编号" prop="postcode">
          <el-input placeholder="请输入邮政编号" v-model="form.postcode"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contactNumber">
          <el-input placeholder="请输入联系方式" v-model="form.contactNumber"></el-input>
        </el-form-item>
        <el-form-item :label="'许可证' + (index + 1)" v-for="(item, index) in form.licenseList" :key="index">
          <el-col :span="16">
            <el-input placeholder="请输入许可证" v-model="item.licenseNumber"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button @click.prevent="removeLicense(item, true)">删除</el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addLicense(true)">增加许可证</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="修改委托公司"
        :visible.sync="dialogVisible2"
        width="550px"
        :before-close="handleClose">
      <el-form ref="model2" :rules="rules" :model="currentRow" label-width="150px">
        <el-form-item label="委托方名称" prop="name">
          <el-input placeholder="请输入委托方名称" v-model="currentRow.name"></el-input>
        </el-form-item>
        <el-form-item label="生产地址" prop="address">
          <el-input placeholder="请输入生产地址" v-model="currentRow.address"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="registerAddress">
          <el-input placeholder="请输入注册地址" v-model="currentRow.registerAddress"></el-input>
        </el-form-item>
        <el-form-item label="邮政编号" prop="postcode">
          <el-input placeholder="请输入邮政编号" v-model="currentRow.postcode"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contactNumber">
          <el-input placeholder="请输入联系方式" v-model="currentRow.contactNumber"></el-input>
        </el-form-item>
        <el-form-item :label="'许可证' + (index + 1)" v-for="(item, index) in currentRow.licenseList" :key="index">
          <el-col :span="16">
            <el-input placeholder="请输入许可证" v-model="item.licenseNumber"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button @click.prevent="removeLicense(item, false)">删除</el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addLicense(false)">增加许可证</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate } from '../../utils/common'
  import { apiEdit, apiDelete, apiDetail, apiList } from '../../api/entrust'

  export default {
    mixins: [tableMixin],
    name: 'entrust',
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        list: [],
        total: 0,
        query: {
          query: '',
          companyIds: []
        },
        form: {},
        currentRow: {},
        rules: {
          companyId: [
            { required: true, message: '请选择公司', trigger: 'change' }
          ],
          name: [
            { required: true, message: '请输入委托方名称', trigger: 'blur' },
            { max: 50, message: '长度在 50 个字符之内', trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请输入生产地址', trigger: 'blur' },
            { max: 100, message: '长度在 100 个字符之内', trigger: 'blur' }
          ],
          registerAddress: [
            { required: true, message: '请输入注册地址', trigger: 'blur' },
            { max: 100, message: '长度在 100 个字符之内', trigger: 'blur' }
          ],
          postcode: [
            { required: true, message: '请输入邮政编码', trigger: 'blur' }
          ],
          contactNumber: [
            { required: true, message: '请输入联系方式', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      this.query.companyIds = [this.userInfo.companyList[0].id]
      this._getList()
    },
    activated() {
    },
    methods: {
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 打开model
      openModel() {
        this.form = {
          companyId: '',
          name: '',
          address: '',
          registerAddress: '',
          postcode: '',
          contactNumber: '',
          licenseList: [{
            licenseNumber: '',
            origin: 2
          }]
        }
        if (this.userInfo.companyList.length === 1) {
          this.form.companyId = this.userInfo.companyList[0].id
        }
        this.dialogVisible = true
        if (this.$refs['model1']) {
          this.$refs['model1'].resetFields()
        }
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
          this.form = {}
          this.currentRow = {}
        }).catch(_ => {})
      },
      // 增加许可证
      addLicense(flag) {
        if (flag) {
          this.form.licenseList.push({
            licenseNumber: '',
            origin: 2
          })
        } else {
          this.currentRow.licenseList.push({
            companyId: this.currentRow.id,
            licenseNumber: '',
            origin: 2
          })
        }
      },
      // 删除许可证
      removeLicense(item, flag) {
        let index = -1
        if (flag) {
          index = this.organization.licenseList.indexOf(item)
          if (index !== -1 && this.organization.licenseList.length > 1) {
            this.organization.licenseList.splice(index, 1)
          }
        } else {
          index = this.currentRow.licenseList.indexOf(item)
          if (index !== -1 && this.currentRow.licenseList.length > 1) {
            this.currentRow.licenseList.splice(index, 1)
          }
        }
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      // 获取列表
      _getList(pageIndex = 1) {
        apiList(this.query, pageIndex).then(data => {
          this.list = data.data.data
          this.total = data.data.total
        })
      },
      // 获取详情
      _getDetail(row) {
        apiDetail(row.id).then(data => {
          this.currentRow = data.data
          this.dialogVisible2 = true
          if (this.$refs['model2']) {
            this.$refs['model2'].resetFields()
          }
        })
      },
      // 添加
      handleAdd() {
        this.$refs['model1'].validate((valid) => {
          if (valid) {
            apiEdit(this.form).then(() => {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
              this._getList()
              this.dialogVisible = false
            })
          }
        })
      },
      // 修改
      handleEdit() {
        this.$refs['model2'].validate((valid) => {
          if (valid) {
            let params = {
              id: this.currentRow.id,
              companyId: this.currentRow.companyId,
              name: this.currentRow.name,
              address: this.currentRow.address,
              registerAddress: this.currentRow.registerAddress,
              postcode: this.currentRow.postcode,
              contactNumber: this.currentRow.contactNumber,
              licenseList: this.currentRow.licenseList
            }
            apiEdit(params).then(() => {
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this._getList()
              this.dialogVisible2 = false
            })
          }
        })
      },
      // 删除
      handleDelete(row) {
        this.$confirm(`是否删除委托方公司：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDelete(row.id, 2).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this._getList()
          })
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.entrust-index
    .btn-left
      background #A5CE1C
      color #fff
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
        margin-right 10px
      .search-input2
        margin-right 10px
    .el-form-item__content
      width 200px
</style>
